module.exports = __webpack_public_path__ + "media/images/v2/illustration_6-9f054baef25ed758c63e948b639ac69b.svg";